module.exports = __webpack_public_path__ + "img/82.7600c445.webp";